/* ============================================================
   NUVEX BODY — Theme JS
   ============================================================ */
(function () {
  'use strict';

  var overlay = function () { return document.getElementById('NuvexOverlay'); };

  function openOverlay() { var o = overlay(); if (o) o.classList.add('is-active'); document.body.style.overflow = 'hidden'; }
  function closeOverlay() { var o = overlay(); if (o) o.classList.remove('is-active'); document.body.style.overflow = ''; }

  /* ---------- Mobile Nav ---------- */
  function initMobileNav() {
    var burger = document.querySelector('.header__burger');
    var nav = document.getElementById('MobileNav');
    var closeBtn = nav ? nav.querySelector('.mobile-nav__close') : null;
    if (!burger || !nav) return;
    burger.addEventListener('click', function () { nav.classList.add('is-open'); openOverlay(); });
    if (closeBtn) closeBtn.addEventListener('click', function () { nav.classList.remove('is-open'); closeOverlay(); });
  }

  /* ---------- Search toggle ---------- */
  function initSearch() {
    var btn = document.getElementById('SearchToggle');
    var panel = document.getElementById('HeaderSearch');
    if (!btn || !panel) return;
    btn.addEventListener('click', function () {
      panel.classList.toggle('is-open');
      if (panel.classList.contains('is-open')) { var i = panel.querySelector('input'); if (i) i.focus(); }
    });
  }

  /* ---------- Cart Drawer ---------- */
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function openCart() { var d = document.getElementById('CartDrawer'); if (d) { d.classList.add('is-open'); openOverlay(); } }
  function closeCart() { var d = document.getElementById('CartDrawer'); if (d) { d.classList.remove('is-open'); closeOverlay(); } }

  function renderCart(cart) {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    var itemsEl = drawer.querySelector('.cart-drawer__items');
    var footerEl = drawer.querySelector('.cart-drawer__footer');
    var emptyEl = drawer.querySelector('.cart-drawer__empty');
    var shippingEl = drawer.querySelector('.cart-drawer__shipping');
    var countEls = document.querySelectorAll('.cart-count, .cart-drawer__count');

    countEls.forEach(function (el) { el.textContent = cart.item_count; });

    if (cart.item_count === 0) {
      if (itemsEl) itemsEl.style.display = 'none';
      if (footerEl) footerEl.style.display = 'none';
      if (shippingEl) shippingEl.style.display = 'none';
      if (emptyEl) emptyEl.style.display = 'flex';
      return;
    }

    if (emptyEl) emptyEl.style.display = 'none';
    if (itemsEl) itemsEl.style.display = 'block';
    if (footerEl) footerEl.style.display = 'block';
    if (shippingEl) shippingEl.style.display = 'block';

    /* Free shipping progress */
    var threshold = (window.NUVEX.freeShippingThreshold || 80) * 100;
    var remaining = threshold - cart.total_price;
    var progressText = drawer.querySelector('.cart-drawer__shipping-text');
    var progressFill = drawer.querySelector('.progress-bar__fill');
    if (progressText) {
      if (remaining > 0) {
        progressText.innerHTML = 'You\'re <strong>' + formatMoney(remaining) + '</strong> away from free shipping!';
      } else {
        progressText.innerHTML = '<strong>You\'ve unlocked free shipping! 🎉</strong>';
      }
    }
    if (progressFill) {
      var pct = Math.min(100, (cart.total_price / threshold) * 100);
      progressFill.style.width = pct + '%';
    }

    /* Items */
    if (itemsEl) {
      itemsEl.innerHTML = cart.items.map(function (item) {
        var img = item.image ? item.image.replace(/(\.[^.]+)$/, '_160x$1') : '';
        var variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
        return '' +
          '<div class="cart-item" data-key="' + item.key + '">' +
            '<img class="cart-item__img" src="' + img + '" alt="' + item.product_title + '">' +
            '<div>' +
              '<div class="cart-item__name">' + item.product_title + '</div>' +
              (variant ? '<div class="cart-item__variant">' + variant + '</div>' : '') +
              '<div class="qty-control">' +
                '<button data-action="minus" data-key="' + item.key + '">&minus;</button>' +
                '<input type="text" value="' + item.quantity + '" readonly>' +
                '<button data-action="plus" data-key="' + item.key + '">+</button>' +
              '</div>' +
              '<button class="cart-item__remove" data-action="remove" data-key="' + item.key + '">Remove</button>' +
            '</div>' +
            '<div class="cart-item__col-right">' +
              '<div class="cart-item__price">' + formatMoney(item.final_line_price) + '</div>' +
            '</div>' +
          '</div>';
      }).join('');
    }

    var subtotalEl = drawer.querySelector('.cart-drawer__subtotal-value');
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
  }

  function fetchCart() {
    return fetch(window.NUVEX.cartUrl + '.js').then(function (r) { return r.json(); }).then(function (cart) {
      renderCart(cart);
      return cart;
    });
  }

  function changeCart(key, quantity) {
    return fetch(window.NUVEX.cartChangeUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      renderCart(cart);
      return cart;
    });
  }

  function addToCart(id, quantity) {
    return fetch(window.NUVEX.cartAddUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: id, quantity: quantity || 1 })
    }).then(function (r) { return r.json(); }).then(function () {
      return fetchCart();
    }).then(function (cart) {
      openCart();
      return cart;
    });
  }

  function initCart() {
    var drawer = document.getElementById('CartDrawer');
    var triggers = document.querySelectorAll('[data-cart-toggle]');
    triggers.forEach(function (t) {
      t.addEventListener('click', function (e) { e.preventDefault(); openCart(); fetchCart(); });
    });
    if (drawer) {
      var closeBtn = drawer.querySelector('.cart-drawer__close');
      if (closeBtn) closeBtn.addEventListener('click', closeCart);

      drawer.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-action]');
        if (!btn) return;
        var key = btn.getAttribute('data-key');
        var action = btn.getAttribute('data-action');
        var row = drawer.querySelector('.cart-item[data-key="' + key + '"]');
        var input = row ? row.querySelector('input') : null;
        var qty = input ? parseInt(input.value, 10) : 1;
        if (action === 'plus') changeCart(key, qty + 1);
        else if (action === 'minus') changeCart(key, Math.max(0, qty - 1));
        else if (action === 'remove') changeCart(key, 0);
      });
    }

    /* Quick add buttons + product form */
    document.addEventListener('click', function (e) {
      var qa = e.target.closest('[data-quick-add]');
      if (qa) {
        e.preventDefault();
        var vid = qa.getAttribute('data-variant-id');
        if (vid) { qa.disabled = true; addToCart(vid, 1).finally(function () { qa.disabled = false; }); }
      }
    });

    var productForm = document.getElementById('ProductForm');
    if (productForm) {
      productForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var idField = productForm.querySelector('[name="id"]');
        var qtyField = productForm.querySelector('[name="quantity"]');
        var btn = productForm.querySelector('[type="submit"]');
        if (!idField) return;
        if (btn) btn.disabled = true;
        addToCart(idField.value, qtyField ? parseInt(qtyField.value, 10) : 1)
          .finally(function () { if (btn) btn.disabled = false; });
      });
    }

    fetchCart();
  }

  /* ---------- Overlay click closes everything ---------- */
  function initOverlayClose() {
    var o = overlay();
    if (o) o.addEventListener('click', function () {
      closeCart();
      var mn = document.getElementById('MobileNav'); if (mn) mn.classList.remove('is-open');
      closeOverlay();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeCart();
        var mn = document.getElementById('MobileNav'); if (mn) mn.classList.remove('is-open');
        closeOverlay();
      }
    });
  }

  /* ---------- Accordions ---------- */
  function initAccordions() {
    document.querySelectorAll('.accordion__trigger').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var panel = trigger.nextElementSibling;
        trigger.classList.toggle('is-open');
        if (panel.style.maxHeight) panel.style.maxHeight = null;
        else panel.style.maxHeight = panel.scrollHeight + 'px';
      });
    });
  }

  /* ---------- Product gallery ---------- */
  function initGallery() {
    var main = document.querySelector('.product__main-img img');
    var thumbs = document.querySelectorAll('.product__thumb');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-full');
        if (src) main.src = src;
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  }

  /* ---------- Product variant options ---------- */
  function initProductOptions() {
    var form = document.getElementById('ProductForm');
    if (!form) return;
    var optionInputs = form.querySelectorAll('.option-value input');
    optionInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        var group = input.closest('.option-values');
        group.querySelectorAll('.option-value').forEach(function (l) { l.classList.remove('is-selected'); });
        input.closest('.option-value').classList.add('is-selected');
        updateVariant(form);
      });
    });
    /* preselect first available */
    form.querySelectorAll('.option-values').forEach(function (group) {
      var first = group.querySelector('input');
      if (first) { first.checked = true; first.closest('.option-value').classList.add('is-selected'); }
    });
    updateVariant(form);
  }

  function updateVariant(form) {
    if (!window.NUVEX_VARIANTS) return;
    var selected = [];
    form.querySelectorAll('.option-values').forEach(function (group) {
      var checked = group.querySelector('input:checked');
      if (checked) selected.push(checked.value);
    });
    var match = window.NUVEX_VARIANTS.find(function (v) {
      return v.options.every(function (opt, i) { return opt === selected[i]; });
    });
    var idField = form.querySelector('[name="id"]');
    var priceEl = document.querySelector('.product__price-current');
    var btn = form.querySelector('[type="submit"]');
    if (match && idField) {
      idField.value = match.id;
      if (priceEl) priceEl.textContent = formatMoney(match.price);
      if (btn) {
        btn.disabled = !match.available;
        btn.textContent = match.available ? 'Add to Cart' : 'Sold Out';
      }
    }
  }

  /* ---------- Init ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    initMobileNav();
    initSearch();
    initCart();
    initOverlayClose();
    initAccordions();
    initGallery();
    initProductOptions();
  });
})();
